import { render, staticRenderFns } from "./pos-fix-salary.vue?vue&type=template&id=15826a2a"
import script from "./pos-fix-salary.vue?vue&type=script&lang=js"
export * from "./pos-fix-salary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports